import React, { useContext, useEffect, useState } from "react"
import TenantConnectionContext, { Provider } from "./TenantConnectionContext"
import TenantConnectionDetails from "./TenantConnectionDetails"
import TenantConnectionForm from "./TenantConnectionForm"
import RevenovaAuthForm from "./RevenovaAuthForm"
import McApiAuthForm from "./McApiAuthForm"
import TaiAuthForm from "./TaiAuthForm"
import AlvysAuthForm from "./AlvysAuthForm"
import ThreeGAuthForm from "./ThreeGAuthForm"

// Embeddable outbound-auth editor for a single tenant identified by SCAC.
// Wraps the TenantConnection provider, drives it from the passed `scac`, and
// toggles between the read-only details and the structured edit form. Used by
// the standalone screen and by Onboarding Status (post-SCAC-search).
//
// The read-only details view is shared across api_types; the edit form is
// api_type-specific — REVENOVA (Salesforce) auth lives in config.oauth_config
// keyed by an auth_type, so it gets a dedicated form.
function Inner({ scac }) {
  const { setScac, tenantData } = useContext(TenantConnectionContext)
  const [showForm, setShowForm] = useState(false)

  useEffect(() => {
    setScac(scac || "")
    setShowForm(false)
  }, [scac])

  if (!scac) return null

  if (!showForm) {
    return <TenantConnectionDetails handleEdit={() => setShowForm(true)} />
  }

  const hideForm = () => setShowForm(false)
  const apiType = tenantData?.api_type || ""
  if (apiType === "REVENOVA") return <RevenovaAuthForm hideForm={hideForm} />
  if (apiType === "MC_API") return <McApiAuthForm hideForm={hideForm} />
  if (apiType === "TAI") return <TaiAuthForm hideForm={hideForm} />
  if (apiType === "ALVYS") return <AlvysAuthForm hideForm={hideForm} />
  if (apiType === "3G") return <ThreeGAuthForm hideForm={hideForm} />
  return <TenantConnectionForm hideForm={hideForm} />
}

function TenantAuthConfig({ scac }) {
  return (
    <Provider>
      <Inner scac={scac} />
    </Provider>
  )
}

export default TenantAuthConfig
